import React from 'react';
import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import {Route, Switch, withRouter} from 'react-router-dom';
import rawTheme from './../../../theme.json';
import PublicItemPage from "../explore/items/item-viewer/PublicItemPage";
import ExternalAppBar from "../../organisms/app-bar/ExternalAppBar";
import PublicAvatarPage from "../avatar/share/PublicAvatarPage";


const muiTheme = createTheme(rawTheme);

function View() {
  return (
    <MuiThemeProvider theme={muiTheme}>
      <ExternalAppBar />
      <Switch>
        <Route path="/view/item/:shareHash" component={props => <PublicItemPage {...props} />} />
        <Route path="/view/avatar/:botName" component={props => <PublicAvatarPage {...props} />} />
      </Switch>
    </MuiThemeProvider>
  );
}

export default withRouter(View);
